// extracted by mini-css-extract-plugin
module.exports = {"container":"DeepDiveVideo-module--container--249Gd","video":"DeepDiveVideo-module--video--3QVRV","close":"DeepDiveVideo-module--close--1bzzl"};